import React, { useState } from 'react';
import './room3.css';

const MirrorPuzzle = ({ onClose, onSolve }) => {
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = () => {
    if (input === '2847') {
      onSolve();
    } else {
      setError(true);
      setTimeout(() => setError(false), 800);
    }
  };

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div className={`puzzlemodal ${error ? 'puzzleshake' : ''}`} onClick={e => e.stopPropagation()}>
        <button className="puzzleclose" onClick={onClose}>✕</button>
        <h2 className="puzzletitle">THE MIRROR</h2>
        <p className="puzzlesubtitle">You see a number scratched into the floor of the reflection.</p>

        <div className="mirrorinputrow">
          <input
            className="puzzleinput"
            maxLength={4}
            value={input}
            onChange={e => { setInput(e.target.value.replace(/\D/g, '')); setError(false); }}
            placeholder="_ _ _ _"
          />
          <button className="puzzlesubmit" onClick={handleSubmit}>UNLOCK</button>
        </div>

        {error && <p className="puzzleerror">Wrong code. Look more carefully.</p>}
      </div>
    </div>
  );
};

export default MirrorPuzzle;